import { createFileRoute } from "@tanstack/react-router";

import { SyncReviewsPage } from "../../../features/pos/sync-reviews-page";

export const Route = createFileRoute("/_app/pos/reviews")({ component: SyncReviewsPage });
